import { isNullOrUndefined } from '@syncfusion/ej2-base';
import { _PdfName, _stringToBytes } from '@syncfusion/ej2-pdf';
/**
 * ImageStructureBase
 *
 * @hidden
 */
export class ImageStructureBase {
    constructor(stream, fontDictionary) {
        this.mIsImageStreamParsed = false;
        this.mIsImageInterpolated = false;
        this.isDualFilter = false;
        this.numberOfComponents = 0;
        if (!isNullOrUndefined(fontDictionary)) {
            this.mImageStream = stream;
            this.mImageDictionary = fontDictionary;
        }
    }
    /**
     * @private
     *@returns {void}
     */
    getImageStream() {
        this.mIsImageStreamParsed = true;
        let IsDecodeFilterDefined = true;
        const ImageDictionary = this.mImageDictionary;
        this.getImageInterpolation(ImageDictionary);
        const imageFilter = this.setImageFilter();
        const imageUnit8Array = this.imageStream();
        if (isNullOrUndefined(imageFilter)) {
            this.mImageFilter.push('FlateDecode');
            IsDecodeFilterDefined = false;
        }
        if (!isNullOrUndefined(imageFilter)) {
            for (let i = 0; i < imageFilter.length; i++) {
                if (imageFilter.length > 1) {
                    this.isDualFilter = true;
                }
                switch (imageFilter[parseInt(i.toString(), 10)]) {
                    case 'DCTDecode': {
                        if (!this.mImageDictionary.has('SMask') && !this.mImageDictionary.has('Mask')) {
                            const colorSpace = this.setColorSpace();
                            if (colorSpace.name === 'DeviceCMYK' || colorSpace.name === 'DeviceN' || colorSpace.name === 'DeviceGray' || colorSpace.name === 'Separation' || colorSpace.name === 'DeviceRGB' || (colorSpace.name === 'ICCBased' && this.numberOfComponents === 4)) {
                                if (colorSpace.name === 'DeviceRGB' && (this.mImageDictionary.has('DecodeParms') || this.mImageDictionary.has('Decode'))) {
                                    break;
                                }
                            }
                        }
                    }
                }
            }
            this.mImageFilter = null;
            return imageUnit8Array;
        }
        return null;
    }
    setColorSpace() {
        if (isNullOrUndefined(this.mColorspace)) {
            this.getColorSpace();
            return this.mColorspace;
        }
    }
    getColorSpace() {
        if (this.mImageDictionary.has('ColorSpace')) {
            this.internalColorSpace = '';
            let value = null;
            if (this.mImageDictionary.has('ColorSpace')) {
                const array = this.mImageDictionary.getArray('ColorSpace');
                if (array && Array.isArray(array) && array.length > 0) {
                    value = this.mImageDictionary.get('ColorSpace');
                }
            }
            if (this.mImageDictionary.get('ColorSpace') instanceof _PdfName) {
                this.mColorspace = this.mImageDictionary.get('ColorSpace');
            }
        }
    }
    setImageFilter() {
        if (isNullOrUndefined(this.mImageFilter)) {
            this.mImageFilter = this.getImageFilter();
        }
        return this.mImageFilter;
    }
    getImageFilter() {
        const imageFilter = [];
        if (!isNullOrUndefined(this.mImageDictionary)) {
            if (this.mImageDictionary.has('Filter')) {
                if (this.mImageDictionary.get('Filter') instanceof _PdfName) {
                    imageFilter.push(this.mImageDictionary.get('Filter').name);
                }
            }
        }
        return imageFilter;
    }
    getImageInterpolation(imageDictionary) {
        if (!isNullOrUndefined(imageDictionary) && imageDictionary.has('Interpolate')) {
            this.mIsImageInterpolated = imageDictionary.get('Interpolate');
        }
    }
    imageStream() {
        const content = _stringToBytes(this.mImageStream.getString(), false, true);
        return content;
    }
    /**
     * @private
     * @returns {void}
     */
    destroy() {
        this.mImageDictionary = null;
        this.mIsImageStreamParsed = null;
        this.mIsImageInterpolated = null;
        this.mImageFilter = null;
        this.isDualFilter = null;
        this.mColorspace = null;
        this.numberOfComponents = null;
        this.internalColorSpace = null;
        this.mImageStream = null;
    }
}
